/**
 * Layout Constants for Tenant Portal Responsive Design
 * 
 * This file contains all magic numbers and hardcoded values used across
 * the responsive layout components to ensure consistency and maintainability.
 */

// Z-Index Layers
export const Z_INDEX = {
  // Dropdown and overlays
  DROPDOWN: 1001,
  DROPDOWN_CONTENT: 1002,

  // Ledger toolbar "Download" popover — single source of truth for its
  // stacking. Kept low (sits above sibling toolbar content only; it is
  // not a page-level overlay) to preserve the original local stacking.
  LEDGER_DOWNLOAD_POPOVER: 10,
  
  // Modal overlays
  OVERLAY: 1000,
  SIDEBAR_OVERLAY: 1200,
  
  // Sidebars
  SIDEBAR: 1001,
  SIDEBAR_CONTENT: 1201,
  
  // Top navigation
  TOP_NAV: 1000,
  TOP_NAV_DROPDOWN: 1001,
}

// Component Widths
export const WIDTHS = {
  // Mobile sidebar widths
  MOBILE_SIDEBAR: '280px',
  MOBILE_SIDEBAR_PERCENTAGE: '85%',
  
  // Tablet sidebar widths
  TABLET_SIDEBAR: '320px',
  
  // Desktop sidebar widths
  DESKTOP_SIDEBAR: '148px',
  DESKTOP_SIDEBAR_4K: '3px',
  
  // Unit selection dropdown
  UNIT_SELECTION_DESKTOP: '228px',
  UNIT_SELECTION_MOBILE: 'calc(100% - 32px)',
  
  // Property card
  PROPERTY_CARD: '352px',
  PROPERTY_CARD_OLD: '319px',
}

// Heights
export const HEIGHTS = {
  // Top navigation heights
  MOBILE_HEADER: '60px',
  TABLET_HEADER: '64px',
  DESKTOP_HEADER: '57px',
  
  // Property card heights (mobile/tablet)
  PROPERTY_CARD_MOBILE: '37px',
  PROPERTY_CARD_CONTENT_MOBILE: '25px',
  
  // Touch target minimum (for accessibility)
  MIN_TOUCH_TARGET: '44px',
}

// Spacing/Padding
export const SPACING = {
  // Padding for different screen sizes
  MOBILE_PADDING: '16px',
  TABLET_PADDING: '20px',
  DESKTOP_PADDING: '24px',
  
  // Margins
  MOBILE_MARGIN: '16px',
  TABLET_MARGIN: '20px',
  DESKTOP_MARGIN: '24px',
  
  // Header sidebar offset for negative margins
  HEADER_SIDEBAR_OFFSET: '-38px',
}

// Spacing Multipliers for calc() expressions with --spacing-scale
export const SPACING_MULTIPLIERS = {
  // Tab navigation spacing multipliers (in rem units)
  TAB_NAV_TOP: 0.625,     // 10px base (0.625rem * 1.5 = 15px comfortable)
  TAB_NAV_LEFT: 2.9375,   // 47px base (2.9375rem * 1.5 = 70.5px comfortable)
  
  // Page header spacing multipliers
  PAGE_HEADER_MOBILE_HORIZONTAL: 1.25,   // 20px base
  PAGE_HEADER_TABLET_HORIZONTAL: 2,      // 32px base  
  PAGE_HEADER_DESKTOP_HORIZONTAL: 4,     // 64px base
  
  // Component padding multipliers
  OPTION_HORIZONTAL: 1.5,                // 24px base
  TOP_NAV_HORIZONTAL: 1.5,              // 24px base
  PAGE_HEADER_SMALL: 1,                 // 16px base
}

// Border Radius
export const BORDER_RADIUS = {
  SMALL: '8px',
  MEDIUM: '12px',
  LARGE: '16px',
  CIRCLE: '50%',
}

// Shadows
export const SHADOWS = {
  LIGHT: '0 2px 4px rgba(0, 0, 0, 0.1)',
  MEDIUM: '0 4px 12px rgba(0, 0, 0, 0.15)',
  HEAVY: '0 8px 32px rgba(0, 0, 0, 0.12)',
  SIDEBAR: '2px 0 10px rgba(0, 0, 0, 0.1)',
  CARD: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
}

// Transitions
export const TRANSITIONS = {
  FAST: '0.2s ease',
  NORMAL: '0.3s ease',
  SLOW: '0.5s ease',
}

// Responsive viewport heights
export const VIEWPORT_HEIGHTS = {
  MOBILE_MAX: '70vh',
  TABLET_MAX: '86vh',
  DESKTOP_MAX: '60vh',
}

export default {
  Z_INDEX,
  WIDTHS,
  HEIGHTS,
  SPACING,
  SPACING_MULTIPLIERS,
  BORDER_RADIUS,
  SHADOWS,
  TRANSITIONS,
  VIEWPORT_HEIGHTS,
}

